import { useDroppable } from '@dnd-kit/core';
import {
  DayPart,
  PlanningEntityIdentifier,
  PlanningEntityType
} from 'generated';

import { PRIMARY } from 'constants/colors';
import { CARD_WIDTH } from 'constants/widths';

import { formatSecondsToHoursMinutes } from 'utils/date';

import { Box } from '@mui/material';
import { brightness } from 'utils/misc';
import { panelThemeColors, PanelTheme } from '../ActivityPanel/constants';
import { StyledExtraSmallIcon } from 'components/shared/Icon/Icon.styles';

interface FreeTimeProps {
  id: string;
  dayPart: DayPart;
  scheduleStart: string;
  start: string;
  durationInSeconds: number;
  planningEntityType: PlanningEntityType;
  planningEntityId: string;
  planningEntityIdentifier: PlanningEntityIdentifier;
}

export default function FreeTime({
  id,
  dayPart = 'MORNING',
  scheduleStart,
  start,
  durationInSeconds,
  planningEntityType,
  planningEntityId,
  planningEntityIdentifier
}: FreeTimeProps) {
  const { setNodeRef, isOver } = useDroppable({
    id,
    data: {
      scheduleStart,
      start,
      planningEntityType,
      planningEntityId,
      planningEntityIdentifier
    }
  });

  const { borderColor, textColor } = panelThemeColors[dayPart as PanelTheme];

  return (
    <Box
      component="li"
      ref={setNodeRef}
      className="freetime-container"
      sx={{
        height: '45px',
        margin: '-10px 0',
        padding: '10px 0',
        width: CARD_WIDTH,
        '&:first-of-type': {
          marginTop: '-20px'
        },
        '&:last-of-type': {
          margin: '-10px 0'
        },
        // Last child that is not also the first child
        '&:last-of-type:not(:first-of-type)': {
          marginTop: '0'
        },
        '+ .traveltime-container': {
          marginTop: '-25px'
        }
      }}
    >
      <Box
        display="flex"
        flexShrink={0}
        justifyContent="center"
        alignItems="center"
        className="freetime"
        my={1}
        sx={{
          boxSizing: 'border-box',
          height: '30px',
          width: '100%',
          color: textColor,
          backgroundColor: isOver ? brightness(PRIMARY, 90) : 'transparent',
          fontSize: '12px',
          fontFamily: 'SourceSansPro-Regular',
          borderRadius: '4px',
          border: isOver ? `2px solid ${PRIMARY}` : `1px dashed ${borderColor}`,
          transition: 'border-color 0.2s ease-in-out'
        }}
      >
        <StyledExtraSmallIcon type="clock" sx={{ marginRight: '8px' }} />
        {`${formatSecondsToHoursMinutes(durationInSeconds)} vrije ruimte`}
      </Box>
    </Box>
  );
}
